import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './components/SessionStatus/SessionStoreSetter';
import { analyticsResetTimerSlice } from './lib/redux/analytics/slice';
import { leaderboardMembershipsSlice } from './lib/redux/leaderboard/slice';
import { metricDataSlice } from './lib/redux/analytics/slice';
import { stageConfigSlice } from './lib/redux/analytics/stage-definitions';
import {
  analyticsDateFilterSlice,
  analyticsFilterSlice,
  analyticsTranscriptFilterSlice,
  historyFilterSlice,
  transcriptDateFilterSlice
} from './lib/redux/filters/slice';
import { emailsValuePropsSlice, settingsSlice, cnamRegistrationsSlice, phoneNumbersSlice } from './lib/redux/users/slice';
import { pendingReviewsSlice } from './lib/redux/sessions/lists/list-slice';
import { namedPersonSearchSlice } from './lib/redux/sessions/data/search-slice';
import {
  adminWriteSlice, pendingAuthorizationInfo, scopesSlice, teamSlice, userGroupsSlice, userSlice,
  userAuthSlice, visibleAccountsSlice, customDefinitionsSlice
} from './lib/redux/users/slice';
import {
  allSyntheticConversationalDataSlice, globalBotsSlice, syntheticConversationalDataSlice, syntheticSessionQueryDataSlice,
  teamBotsSlice, activeSynthCallSlice, callAnalysisSlice, botsToEmotionSlice
} from './lib/redux/bots/generic-bot-slice';
import { teamBotSkillsSlice, globalBotSkillsSlice } from './lib/redux/bots/generic-bot-slice';
import { linkedInClientsSlice } from './lib/redux/linkedin/client/slice';
import { searchResultsSlice } from './lib/redux/linkedin/search/slice';
import { chatConversationsSlice } from './lib/redux/linkedin/conversations/chat-slice';
import { salesNavigatorConversationsSlice } from './lib/redux/linkedin/conversations/sales-nav-slice';
import { conversationStatesSlice, LINKEDIN_STATES_STORAGE_KEY } from './lib/redux/linkedin/metadata/slice';
import { analyzeSlice } from './lib/redux/linkedin/conversations/analyze-slice';
import { selectedConversationSlice as selectedLinkedInSlice } from './lib/redux/linkedin/navigate/slice';
import { temporarySlice } from './lib/redux/linkedin/conversations/temporary-slice';
import { newConversationSlice } from './lib/redux/linkedin/new-conversation/slice';
import { snippetsSlice } from './lib/redux/linkedin/snippets/slice';
import { linkedinVoiceNotesSlice } from './lib/redux/linkedin/voice-memos/slice';
import { salesFloorSlice } from './lib/redux/salesfloor/slice';
import { sessionListSlice, refreshSlice } from './lib/redux/sessions/lists/list-slice';
import { sessionDetailsSlice } from './lib/redux/sessions/data/data-slice';
import { sessionAudioSlice } from './lib/redux/sessions/audio/audio-slice';
import { practiceBotSlice } from './lib/redux/bots/session-bot-slices';
import { enableMapSet } from 'immer'
import { textingNumbersSlice, textingMessagesSlice, textSessionSlice } from './lib/redux/sessions/texting/slice';
import { enrichSlice } from './lib/redux/sessions/enrich/slice';
import { dispositionOptionSlice, prospectInfoOptionSlice } from './lib/redux/filters/options/options';
import { aiAnalysisSlice } from './lib/redux/analytics/analysis';
import { analyticsTranscriptViewerSlice } from './lib/redux/analytics/transcript-viewer-slice';
import { googleSheetsSlice } from './lib/redux/sheets/slice';
import { savedViewsSlice } from './lib/redux/views/slice';
import { leaderboardMetricsSlice } from './lib/redux/leaderboard-metrics/slice';
import { provisionedTeamSelectorSlice } from './lib/redux/provisioned/slice';
import inboundRoutesReducer from './lib/redux/routes/slice';
import promptsReducer from './lib/redux/prompts/slice';
import voiceBotsReducer from './lib/redux/voice-bots/slice';
import chatBotsReducer from './lib/redux/chat-bots/slice';
import phoneNumbersReducer from './lib/redux/phone-numbers/slice';
import { autodialerMappingsSlice } from 'lib/redux/settings/autodialerMappingsSlice';
import { customScoresSlice } from './lib/redux/custom-scores/slice';
import { autodialerSettingsReducer } from './lib/redux/settings/autodialerSettingsSlice';
import platformDispositionsReducer from './lib/redux/settings/platformDispositionsSlice';
import payloadManagementReducer from './lib/redux/payloads/slice';
import { interviewSlice } from './lib/redux/interview/slice';
import interviewPortalAdminReducer from './lib/redux/interview/admin/slice';
import { liveListenSlice } from './lib/redux/live-listen/slice';
import { liveListenSignalsSlice } from './lib/redux/live-listen/signalsSlice';
// Add this line near the top of the file, before creating the store
enableMapSet()

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    userGroupInfo: userGroupsSlice.reducer,
    scope: scopesSlice.reducer,
    adminWrite: adminWriteSlice.reducer,
    user: userSlice.reducer,
    userAuth: userAuthSlice.reducer,
    team: teamSlice.reducer,
    visibleAccounts: visibleAccountsSlice.reducer,
    customDefinitions: customDefinitionsSlice.reducer,
    customScores: customScoresSlice.reducer,
    provisionedTeamSelector: provisionedTeamSelectorSlice.reducer,
    inboundRoutes: inboundRoutesReducer,
    pendingReviews: pendingReviewsSlice.reducer,
    authenticationInfo: pendingAuthorizationInfo.reducer,
    emailValueProps: emailsValuePropsSlice.reducer,
    dispositionOptions: dispositionOptionSlice.reducer,
    prospectInfoOptions: prospectInfoOptionSlice.reducer,
    cnamRegistrations: cnamRegistrationsSlice.reducer,
    twilioPhoneNumbers: phoneNumbersSlice.reducer,
    analyticsFilter: analyticsFilterSlice.reducer,
    historyFilter: historyFilterSlice.reducer,
    analyticsTranscriptFilter: analyticsTranscriptFilterSlice.reducer,
    analyticsDateFilter: analyticsDateFilterSlice.reducer,
    settings: settingsSlice.reducer,
    metricData: metricDataSlice.reducer,
    namedPersonSearch: namedPersonSearchSlice.reducer,
    teamBots: teamBotsSlice.reducer,
    globalBots: globalBotsSlice.reducer,
    teamBotSkills: teamBotSkillsSlice.reducer,
    globalBotSkills: globalBotSkillsSlice.reducer,
    synthConversations: syntheticConversationalDataSlice.reducer,
    synthConversationQueryParam: syntheticSessionQueryDataSlice.reducer,
    allSynthConversations: allSyntheticConversationalDataSlice.reducer,
    activeSynthCall: activeSynthCallSlice.reducer,
    callAnalysis: callAnalysisSlice.reducer,
    botsToEmotion: botsToEmotionSlice.reducer,
    linkedinClients: linkedInClientsSlice.reducer,
    linkedinSearchResults: searchResultsSlice.reducer,
    linkedinChatConversations: chatConversationsSlice.reducer,
    linkedinSalesNavigatorConversations: salesNavigatorConversationsSlice.reducer,
    linkedinConversationStates: conversationStatesSlice.reducer,
    linkedinAnalyze: analyzeSlice.reducer,
    linkedinSelected: selectedLinkedInSlice.reducer,
    linkedinTemporary: temporarySlice.reducer,
    linkedinNewConversation: newConversationSlice.reducer,
    linkedinSnippets: snippetsSlice.reducer,
    linkedinVoiceNotes: linkedinVoiceNotesSlice.reducer,
    leaderboardMemberships: leaderboardMembershipsSlice.reducer,
    analyticsResetTimer: analyticsResetTimerSlice.reducer,
    salesFloor: salesFloorSlice.reducer,
    sessionList: sessionListSlice.reducer,
    sessionDetails: sessionDetailsSlice.reducer,
    sessionAudio: sessionAudioSlice.reducer,
    practiceBot: practiceBotSlice.reducer,
    refresh: refreshSlice.reducer,
    textingNumbers: textingNumbersSlice.reducer,
    textingMessages: textingMessagesSlice.reducer,
    textingSessions: textSessionSlice.reducer,
    transcriptDateFilter: transcriptDateFilterSlice.reducer,
    enrich: enrichSlice.reducer,
    stageConfig: stageConfigSlice.reducer,
    aiAnalysis: aiAnalysisSlice.reducer,
    analyticsTranscriptViewer: analyticsTranscriptViewerSlice.reducer,
    googleSheets: googleSheetsSlice.reducer,
    savedViews: savedViewsSlice.reducer,
    leaderboardMetrics: leaderboardMetricsSlice.reducer,
    prompts: promptsReducer,
    voiceBots: voiceBotsReducer,
    chatBots: chatBotsReducer,
    phoneNumbers: phoneNumbersReducer,
    autodialerSettings: autodialerSettingsReducer,
    autodialerMappings: autodialerMappingsSlice.reducer,
    platformDispositions: platformDispositionsReducer,
    payloadManagement: payloadManagementReducer,
    interview: interviewSlice.reducer,
    interviewPortalAdmin: interviewPortalAdminReducer,
    liveListen: liveListenSlice.reducer,
    liveListenSignals: liveListenSignalsSlice.reducer,
  },
});

export type AppDispatch = typeof store.dispatch;
// This ensures RootState includes all our reducers with proper typing
export type RootState = ReturnType<typeof store.getState>;


// Add these at the top level of the file
const STORAGE_WRITE_INTERVAL = 5000; // 5 seconds

// Add this function at the top level
function setupStorageWriter() {
  let currentStates = JSON.parse(localStorage.getItem(LINKEDIN_STATES_STORAGE_KEY) || '{}');
  setInterval(() => {
    if (!store || !store.getState || !store.getState().linkedinConversationStates) {
      return;
    }
    const newStates = store.getState().linkedinConversationStates.states;
    if (JSON.stringify(currentStates) !== JSON.stringify(newStates)) {
      currentStates = newStates;
      localStorage.setItem(LINKEDIN_STATES_STORAGE_KEY, JSON.stringify(newStates));
    }
  }, STORAGE_WRITE_INTERVAL);
}

// Call this when your app initializes (e.g., in index.tsx or App.tsx)
setupStorageWriter();
